/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-button-raised[_ngcontent-%COMP%]{width:200px}\n/*# sourceMappingURL=newFolderDialog.component.css.map*/"];
export { styles as styles };
